export default __webpack_public_path__ + "static/media/dds5168_4p-4.14159af3.png";